import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  buttonAgree: {
    width: 102,
    height: 40,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    justifyContent: "center",
  },
  textButton: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  buttonBack: {
    width: width * 0.14,
    height: 40,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    justifyContent: "center",
    marginTop: 20,
    marginBottom: height * 0.2,
  },
  buttonBackRespons: {
    width: width * 0.18,
    height: 40,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    justifyContent: "center",
    marginTop: 20,
    marginBottom: height * 0.2,
  },
  viewModal: {
    width: width * 0.4,
    height: 200,
    backgroundColor: "#FFBEBE",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 40,
    borderRadius: 38,
  },
  textModal: {
    fontSize: 22,
    fontFamily: "Prompt",
    alignSelf: "center",
    color: "#FF4646",
    textAlign: "center",
  },
  imgTitle: {
    width: "50%",
    maxHeight: 451,
    height: "60%",
    alignSelf: "center",
    marginVertical: 40,
  },
  textSubject: {
    fontSize: 28,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textCondition: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginVertical: 11,
  },
});
export const stylesResponsive = StyleSheet.create({
  buttonBack: {
    width: width * 0.5,
    height: 40,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    justifyContent: "center",
    marginTop: 20,
    marginBottom: height * 0.2,
  },
  textButton: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  imgTitle: {
    width: "50%",
    maxHeight: 451,
    height: "60%",
    alignSelf: "center",
    marginVertical: 40,
  },
  textSubject: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textCondition: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginVertical: 11,
  },
});
